import React, { Component } from 'react'
import withExperimentProvider from 'components/hocs/withExperimentProvider'
import { Text } from '@cred/react-text'
import { LendersText } from '@cred/react-marketing'
import PropTypes from 'prop-types'
import RateWidgetFooter from 'components/footer'
import { RateScript as Rate } from '@cred/react-rate/rate-script'
import { AdvertiserDisclosure } from 'components/advertiser-disclosure'
import WidgetPage from 'components/hocs/widget-page'
import ShortenedRateTableApp from './shortened-table'
import FullRateTableApp from './full-table'
import styles from './styles.scss'

class RateTableApp extends Component {
  static propTypes = {
    theme: PropTypes.string,
    variation: PropTypes.string,
  }

  render() {
    const { theme, variation } = this.props,
      isFullTable = variation !== 'shortened',
      showDisclosure = ['fox', 'thebalance1', 'investopedia1'].includes(theme)

    return (
      <>
        { showDisclosure && <AdvertiserDisclosure tooltipId="fox-disclosure" theme={theme} /> }
        <div className={styles.rates}>
          <Text type="subheader" className={styles.header}>Compare student loan refinancing lenders</Text>
          <Text type="body-alt" className={styles.description}>
            Rates from <Rate rateType="apr" vertical="refi" variable name="min" /> APR.
            <LendersText
              startText=" Compare up to"
              endText="lenders."
              defaultText=" Compare up to"
              vertical="refi"
            />
          </Text>

          { isFullTable
            ? <FullRateTableApp {...this.props} />
            : <ShortenedRateTableApp {...this.props} /> }

          <RateWidgetFooter theme={theme} />
        </div>
      </>
    )
  }
}

// Export named class and functions for unit tests
export { RateTableApp }

export default WidgetPage(withExperimentProvider(RateTableApp))
